import apiRequest from '@/services/api-request.js';

const state = {
    prices: []
}

const getters = {
    priceFor: (state) => (catalogNumber) => {
        return state.prices.find(p => p.catalogNumber === catalogNumber)?.price;
    }
}

const actions = {
    fetchCustomerPrices: (context) => {

        const products = [...new Set(context.rootGetters['workflow/wfStaticSteps']
            .flatMap(s => s.products?.filter(
                p => p.itemType !== 'GeneGlobe' 
                && p.publishingStatus === 'PUBLISHED' 
                && p.is_wfc_ready === true).map(s => s.catalogNumber)
            )
        )];

        if (products.length > 0) {
            apiRequest(context.rootState.customerPricesEndpoint, 'post', { products: products }, null, {
                withCredentials: true,
            }).then((response) => {
                context.commit('setPrices', response['prices']);
            });
        }
    },
}

const mutations = {
    setPrices: (state, payload) => {
        state.prices = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}